export enum FilterConditionType {
  LessThan = 'LT',
  LessThanEquals = 'LTE',
  GreaterThan = 'GT',
  GreaterThanEquals = 'GTE',
  Equals = 'EQ',
  Exists = 'EXISTS',
  NotExists = 'NOT_EXISTS',
}
